import { $, addAction, doAction } from '@situation/setdesign.util';

/* global moment */
class CalendarView {
    constructor() {
        this.$modal = $('#calendar-event-modal');

        this.handleEventRender = (event, element) => {
            const $title = $(`<span class="fc-title">${event.title}</span>`);
            const $genre = $(`<span class="fc-genre"> ${event.genre}</span>`);
            const $container = element.find('.fc-content');
            const existingTitle = $container.find('.fc-title').text();
            const label = [`${event.start.format('h:mma, MMMM Do YYYY')}.`, `${existingTitle}.`, event.genre].join(
                ' ',
            );
            $container.find('.fc-title').remove();
            $container.find('.fc-time').wrap("<span class='fc-info'></span>");
            $container.prepend($title);
            $container.find('.fc-info').append($genre);
            element.prepend(event.img.clone());
            element.attr('aria-label', label);
            element.data('date', event.start.format('YYYY-MM-DD'));
        };

        this.render = (_view, $container) => {
            const addEventClass = (_index, eventElement) => {
                const $event = $(eventElement);
                const dateSelector = `[data-date="${$event.data('date')}"]`;
                $container.find(dateSelector).addClass('fc-has-event');
            };

            $container.find('.fc-event').each(addEventClass);

            const handleClick = (event) => {
                const $this = $(event.currentTarget);
                const date = moment($this.data('date'));
                const $date = $(`<h2 class="calendar-modal-date">${date.format('MMMM D, YYYY')}</h2>`);
                const isSameDate = (_index, eventElement) => $(eventElement).data('date') === $this.data('date');
                const $events = $container.find('.fc-event').filter(isSameDate).clone();
                const $modalContent = $('<div class="calendar-modal-events"></div>');
                $modalContent.prepend($date).append($events);
                doAction('buildModal', $modalContent, this.$modal);
            };

            $container.find('.fc-has-event').each((_index, element) => {
                $(element).off('click').on('click', handleClick);
            });
        };

        addAction('calendar/eventRender', this.handleEventRender, 10, this);
        addAction('calendar/viewRender', this.render, 10, this);
    }
}

export default CalendarView;
